export default __webpack_public_path__ + "static/media/intelli.bbaf01eb.JPG";